import { render, staticRenderFns } from "./SendCompanyCopyDialog.vue?vue&type=template&id=173bf812&scoped=true"
import script from "./SendCompanyCopyDialog.vue?vue&type=script&lang=js"
export * from "./SendCompanyCopyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173bf812",
  null
  
)

export default component.exports